import React from "react";
import { Menu } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const StyledMenu = (props) => {

    const {
        isOpen,
        children,
        anchorEl,
        center,
        onClose,
    } = props;

    const CustomMenu = withStyles({
        paper: {
            border: "1px solid var(--borderColor)",
        }
    })((props) => (
        <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: center ? "center" : "right" }}
            transformOrigin={{ vertical: "top", horizontal: center ? "center" : "right" }}
            {...props}
        />
    ));

    return (
        <CustomMenu
            keepMounted
            anchorEl={anchorEl}
            open={isOpen}
            onClose={onClose}>
            {children}
        </CustomMenu>
    );
}

export default StyledMenu;